import React, { useState, useEffect, useImperativeHandle } from "react";
import {
  StyleSheet,
  View,
  Text,
  FlatList,
  Platform,
  ScrollView,
} from "react-native";

import { hasItems } from "../../../../helpers/utils";
import IntegrationWrapper from "../details/IntegrationWrapper";
import ShowMoreItems from "../../common/ShowMoreItems";
import IntegrationMenuOptions from "../common/IntegrationMenuOptions";
import IntegrationsHelper from "../IntegrationsHelper";
import appPages from "../../../../appPages";
import appStyles from "../../../appStyles";

const PAGE_SIZE = 10;

const SourceReceivedData = React.forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    loadData,
  }));

  const { controller, sourceName } = props;

  const initialNumToRender = 3;

  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [message, setMessage] = useState("");
  const [allElements, setAllElements] = useState([]);
  const [elementsList, setElementsList] = useState([]);
  const [selectedIntegration, setSelectedIntegration] = useState(null);

  const loadData = () => {
    const pageLastKnownTime = null;
    const pageLastKnownId = null;
    IntegrationsHelper.getIntegrationDataBySource(
      controller,
      sourceName,
      pageLastKnownTime,
      pageLastKnownId,
    ).then((items) => {
      setAllElements(items);
      if (items?.length > initialNumToRender) {
        setHasMoreItems(true);
        setElementsList(items.slice(0, initialNumToRender));
        setMessage("See more entries");
      } else {
        setHasMoreItems(false);
        setElementsList(items);
      }
    });
  };

  useEffect(() => {
    loadData();
  }, [controller.state?.rules]);

  const showMore = () => {
    const start = elementsList.length;
    const end = start + PAGE_SIZE;

    const newElementsList = [...elementsList, ...allElements.slice(start, end)];
    setElementsList(newElementsList);

    if (end > allElements.length) {
      setHasMoreItems(false);
    }
  };

  return !hasItems(allElements) ? null : (
    <>
      <ScrollView
        style={[appStyles.scrollView, styles.container, props.style]}
        contentContainerStyle={[appStyles.scrollViewContent, { flex: 1 }]}
      >
        <Text style={styles.headerText}>All Received Data</Text>
        <View style={styles.listContainer}>
          <FlatList
            data={elementsList}
            style={{ overflow: "visible" }}
            keyExtractor={(item) =>
              item.id + (item.element ? `-${item.element.id}` : "")
            }
            renderItem={({ item }) => (
              <IntegrationWrapper
                controller={controller}
                data={item}
                showDate={true}
                onLongPress={() => setSelectedIntegration(item)}
                {...props}
                style={{
                  marginBottom: 0,
                  paddingVertical: 4,
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              />
            )}
            ListFooterComponent={
              <ShowMoreItems
                onPress={showMore}
                message={message}
                hasMoreItems={hasMoreItems}
              />
            }
          />
        </View>
      </ScrollView>

      <IntegrationMenuOptions
        controller={controller}
        integration={selectedIntegration}
        close={() => setSelectedIntegration(null)}
        returnUrl={appPages.integrationRulesPage}
      />
    </>
  );
});

export default SourceReceivedData;

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
    flex: 1,
  },
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    paddingLeft: 6,
  },
  listContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    borderWidth: 0,
  },
});
